import { Component, Input, SecurityContext } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Checkbox component to display a checkbox with label and validation messages.
 *
 * @example
 * <cfe-input-checkbox
 *                [control]="formControl"
 *                [label]="'A checkbox'"
 *                [smallLabel]="'with a small label'"
 *                [name]="'name'"
 *                [icon]="'assets/icon.png'"
 *                [centerLabelVertical]="'true'"
 *                [inputHtml]="´<p>Sirona</p>´"
 *                [value]="'value'"
 *                [id]="'description'"
 *                [tabIndex]="1"
 *                [disabled]="false"
 *                [showError]="false"
 *                [notMarkAsRequired]="false">
 * </cfe-input-checkbox>
 */

@Component({
	selector: 'cfe-input-checkbox',
	templateUrl: './input-checkbox.component.html',
	styleUrls: ['./input-checkbox.component.scss']
})
export class InputCheckboxComponent extends InputComponent {
	@Input() name: string;

	@Input() icon: string;

	@Input() smallLabel: string;

	@Input() centerLabelVertical = true;

	@Input() labelStyles: any;

	@Input() value: any = null;

	@Input() inputHtml: string;

	@Input() showError = true;

	htmlCode: SafeHtml;

	constructor(private sanitizer: DomSanitizer) {
		super();
	}

	cfeOnChanges() {
		if (this.inputHtml) {
			this.htmlCode = this.sanitizer.bypassSecurityTrustHtml(this.inputHtml);
		}
	}
}
